
<ion-content>
  <div  *ngIf="tempPermitState.checking"
  style="
  background-color:rgba(255, 255, 255, 0.85);
  position:fixed;
  width:100%;
  height:100%;
  top:0px;
  left:0px;
  z-index:1000;">
 <ion-grid style="height: 100%;">
  
  <ion-row style="height: 50%;">
    <ion-col style="text-align: center;">
      
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="text-align: center;">
      <ion-spinner color="secondary" name="circular"></ion-spinner>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="text-align: center;"> 
      <ion-item lines="none" style="--background:transparent !important;text-align: center;" class="paragraph-input-fields-bold">
      <ion-label class="ion-text-wrap">
        {{('keys.data.permits.temporary_permit_validating' | translate : {Default:'Please wait while we validate your Temporary Permit options.'}) || "Please wait while we validate your Temporary Permit options."}}
      </ion-label>
    </ion-item>
    </ion-col>
  </ion-row>
 </ion-grid>
   
</div>
  <app-pagecontent
    [path]="'permits/temporary/reservation/' + lot.LotNameID"></app-pagecontent>
  <ion-card *ngIf="!loaded">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12">
          <h1 style="text-align: center; font-weight: bold; color: black">
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </h1>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <h2 style="text-align: center">
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="single-col-wider">
          <ion-card>
            <ion-card-header>
              <ion-skeleton-text
                animated
                style="width: 40%"
              ></ion-skeleton-text>
            </ion-card-header>
            <ion-card-content>
              <div>
                <ng-container>
                  <ion-grid class="ion-no-padding">
                    <ion-row>
                      <ion-col>
                        <ion-item clickable lines="none">
                          <ion-label slot="start">
                            <ion-skeleton-text
                              animated
                              style="width: 40%"
                            ></ion-skeleton-text>
                          </ion-label>
                          <ion-label slot="end">
                            <ion-skeleton-text
                              animated
                              style="width: 40%"
                            ></ion-skeleton-text>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row>
                      <ion-col>
                        <ion-item clickable lines="none">
                          <ion-label slot="start"
                            ><ion-skeleton-text
                              animated
                              style="width: 40%"
                            ></ion-skeleton-text
                          ></ion-label>
                          <ion-label slot="end">
                            <ion-skeleton-text
                              animated
                              style="width: 40%"
                            ></ion-skeleton-text>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-row>
                      <ion-col>
                        <ion-item>
                          <ion-label
                            ><ion-skeleton-text
                              animated
                              style="width: 40%"
                            ></ion-skeleton-text
                          ></ion-label>
                        </ion-item>
                        <ion-note
                          ><h6>
                            <ion-skeleton-text
                              animated
                              style="width: 40%"
                            ></ion-skeleton-text></h6
                        ></ion-note>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ng-container>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
  <ion-grid *ngIf="loaded">
    <ion-row>
      <ion-col>
        <ion-header class="remove-margin-from-safe-area ion-no-border" *ngIf="loaded">
          <ion-toolbar >
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-toolbar>
                  <ion-buttons slot="end">
                    <ion-button (click)="closeModal()" 
                      ><ion-icon color="dark" name="close"></ion-icon
                    ></ion-button>
                  </ion-buttons>
                </ion-toolbar>
                </ion-col>
              </ion-row>
              <ion-row >
                <ion-col style="text-align: center;">
                  <h2 class="subheader-regular"> {{ permitsSRV.permit.value['lot'].LotName }}</h2>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-no-padding" style="text-align: center">
                  <ion-label  class="card-text-regular"
                    >{{ ('keys.data.permits.temp_permit' | translate : {Default:'Temporary Permit'})
                    || 'Temporary Permit' }}</ion-label>
                </ion-col>
              </ion-row>
              
              
            </ion-grid>
            
           
          </ion-toolbar>
        </ion-header>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="permitsSRV.permit.value?.lot?.Location">
      <ion-col  style="text-align: center" class="ion-padding">
        <div #divs>
          <div  class="permitDescription" >
          <ion-label >
            {{ permitsSRV.permit.value?.lot?.Location }}
          </ion-label>
        </div>
          <ion-label  style="color: var(--Red-Shade, #A02021);text-decoration: underline;font-weight: bold;cursor: pointer;"
          
          (click)="showMore($event)">Show more</ion-label>
          <ion-label  style="color: var(--Red-Shade, #A02021); text-decoration: underline;font-weight: bold;cursor: pointer;"   (click)="showLess($event)">Show less</ion-label>
          </div>
      </ion-col>
    </ion-row>
    
    <ion-row>
      <ion-col class="single-col-wider">
        <ion-card class="card-shadow-7"
        
      >
        <ion-grid
          *ngIf="permitsSRV.permit.value['status'] == 'success'"
          class="ion-no-padding"
        >
          
         
          <ion-row>
            <ion-col size="12" *ngIf="permitsSRV.permit.value['lot']">
                  <ion-segment  color="dark" style="--background:var(--Gray-300, #F2F2F2);"
                    [(ngModel)]="permitType"
                    (ionChange)="segmentChanged($event)"
                  >
                    <ion-segment-button class="card-text-regular" [disabled]="disableDaily" value="daily" style="--background:var(--Gray-300, #F2F2F2);">
                      <ion-label >{{('keys.data.permits.temp_daily' |
                        translate : {Default:'Daily'}) || 'Daily' }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button style="--background:var(--Gray-300, #F2F2F2);" [disabled]="disableHourly" value="hourly">
                      <ion-label>{{('keys.data.permits.temporary_hourly' |
                        translate : {Default:'Hourly'}) || 'Hourly' }}</ion-label>
                    </ion-segment-button>
                  </ion-segment>
               
                  <div [ngSwitch]="permitType">
                    <ng-container *ngSwitchCase="'daily'">
                      <form novalidate [formGroup]="tempPermitFormDaily">
                        <ion-grid class="ion-no-padding">
                          <ion-row>
                            <ion-col>
                              <ion-item style="cursor: pointer;"
                              [disabled]="tempPermitState.checking"
                              class="paragraph-input-fields-regular"
                                clickable
                                lines="none"
                                (click)="showStartPickerfunction()"
                              >
                                
                                <ion-label >{{('keys.data.permits.start_date' |
                                  translate : {Default:'Start Date'}) || 'Start Date' }} </ion-label>
                                <span style="text-align: right;" *ngIf="formattedStartDate!='Select Start Date'" slot="end">
                                  {{formattedStartDate |
                                    date:dataService.settings['system']['datemask']}}
                                  <ion-icon  name="calendar" >
                                  </ion-icon>
                                </span>
                                <span style="text-align: right;" *ngIf="formattedStartDate=='Select Start Date'" slot="end">
                                  {{formattedStartDate}}
                                  <ion-icon  name="calendar" >
                                  </ion-icon>
                                </span>
                                
                              </ion-item>
                            </ion-col>
                          </ion-row>
                          <ion-row>
                            <ion-col>
                              <ng-container *ngIf="errors['dailyStartDate']">
                                <ion-label class="paragraph-input-fields-regular"
                                  style="text-align: center"
                                  color="danger"
                                  *ngFor="let error of errors['dailyStartDate']"
                                  >{{ error }}
                                </ion-label>
                              </ng-container>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="showStartPicker">
                            <ion-col>
                              <ion-datetime  color="secondary"
                                presentation="date"
                                #datetime
                                (ionChange)="startDateChanged(datetime)"
                                min="{{minDate}}"
                                size="auto"
                                display-format="MMMM DD, YYYY"
                                picker-format="MMMM DD, YYYY"
                                formControlName="dailyStartDate"
                              >
                              </ion-datetime>
                              
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="showStartPicker" style="margin-bottom: 0.5em;">
                            
                            <ion-col>
                              <ion-button 
                                [disabled]="tempPermitFormDaily.get('dailyStartDate').invalid"
                                color="secondary"
                                expand="block"
                                
                                (click)="SaveStartDate()"
                                >{{('keys.data.common.confirm' |
                                translate : {Default:'Confirm'}) || 'Confirm' }}</ion-button
                              >
                              
                            </ion-col>
                            <ion-col>
                              <ion-button 
                              
                              fill="outline"
                              color="secondary"
                              expand="block"
                                (click)="closeStartDate()"
                                >{{('keys.data.common.cancel' |
                                translate : {Default:'Cancel'}) || 'Cancel' }}</ion-button
                              >
                            </ion-col>
                          </ion-row>
                          <ion-row>
                            <ion-col>
                              <ion-item class="paragraph-input-fields-regular"
                              style="cursor: pointer;"
                                [disabled]="formattedStartDate=='Select Start Date' || tempPermitState.checking"
                                clickable
                                lines="none"
                                (click)="showEndPickerfunction()"
                              >
                                
                                <ion-label >{{('keys.data.permits.end_date' |
                                  translate : {Default:'End Date'}) || 'End Date' }} </ion-label>
                                <span style="text-align: right;"  *ngIf="formattedEndDate!='Select End Date'" slot="end">
                                  {{formattedEndDate |
                                    date:dataService.settings['system']['datemask']}}
                                  <ion-icon name="calendar">
                                  </ion-icon>
                                </span>
                                <span style="text-align: right;"  *ngIf="formattedEndDate=='Select End Date'" slot="end">
                                  {{formattedEndDate}}
                                  <ion-icon name="calendar">
                                  </ion-icon>
                                </span>
                              </ion-item>
                            </ion-col>
                          </ion-row>
                          <ion-row>
                            <ion-col>
                              <ng-container *ngIf="errors['dailyEndDate']">
                                <ion-label class="paragraph-input-fields-regular"
                                  style="text-align: center"
                                  color="danger"
                                  *ngFor="let error of errors['dailyEndDate']"
                                  >{{ error }}
                                </ion-label>
                              </ng-container>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="showEndPicker">
                            <ion-col>
                              <ion-datetime *ngIf="permitsSRV.permit.value['lot'].TempPermitOver30days"
                                color="secondary"
                                presentation="date"
                                #datetime2
                                (ionChange)="endDateChanged(datetime2.value)"
                                [min]="tempPermitFormDaily.value['dailyStartDate']"
                                size="auto"
                                display-format="MMMM DD, YYYY"
                                picker-format="MMMM DD, YYYY"
                                formControlName="dailyEndDate"
                              >
                              </ion-datetime>
                              <ion-datetime *ngIf="!permitsSRV.permit.value['lot'].TempPermitOver30days"
                                color="secondary"
                                presentation="date"
                                #datetime2
                                (ionChange)="endDateChanged(datetime2.value)"
                                [min]="tempPermitFormDaily.value['dailyStartDate']"
                                max="{{maxDate}}"
                                size="auto"
                                display-format="MMMM DD, YYYY"
                                picker-format="MMMM DD, YYYY"
                                formControlName="dailyEndDate"
                              >
                              </ion-datetime>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="showEndPicker">
                            <ion-col>
                              <ion-button
                              [disabled]="tempPermitFormDaily.get('dailyEndDate').invalid"
                              color="secondary"
                              
                                expand="block"
                                (click)="SaveEndDate()"
                                >{{('keys.data.common.confirm' |
                                translate : {Default:'Confirm'}) || 'Confirm' }}</ion-button
                              >
                            </ion-col>
                            <ion-col>
                              <ion-button
                                fill="outline"
                                color="secondary"
                                expand="block"
                                (click)="closeEndDate()"
                                >{{('keys.data.common.cancel' |
                                translate : {Default:'Cancel'}) || 'Cancel' }}
                                </ion-button
                              >
                            </ion-col>
                            
                          </ion-row>
                          <ion-row *ngIf="permitsSRV.permit.value['vehicles']">
                            <ion-col>
                              <ion-card class="card-shadow-3">
                                <ion-grid>
                                  <ion-row>
                                    <ion-col>
                                      <ion-label>{{('keys.data.vehicles.vehicle' | translate : {Default:'Vehicle'}) || 'Vehicle'}}</ion-label>
                                    </ion-col>
                                  </ion-row>
                                  <ion-row>
                                    <ion-col>
                                      <ion-item lines="none" >
                                      <ion-select  
                                      style="font-weight: bold;"
                                      [disabled]="tempPermitState.checking"
                                      [mode]="platformSRV.mode"
                                        placeholder="Select Vehicle"
                                        [interface]="platformSRV.interface"
                                        multiple="false"
                                        formControlName="vehicle"
                                        (ionChange)="vehiclesChanged()"
                                      >
                                        <ion-select-option 
                                          *ngFor="let v of permitsSRV.permit.value['vehicles']"
                                          [value]="v.VehicleID"
                                          >{{ v.ColourName }} {{ v.Year }} {{ v.MakeName
                                          }} {{ v.Plate }}</ion-select-option
                                        >
                                        <ion-select-option [value]=guestVehicleID *ngIf="dataService.settings.vehicles.guest_vehicle"
                                          ><ng-container *ngIf="dataService.user as user"
                                            >Guest Vehicle -- Guest of {{
                                            dataService.settings.userProfile.preferredName
                                            && user['preferredname'] ?
                                            user['pereferredname'] : user['firstName'] + '
                                            ' + user['lastName'] }}</ng-container
                                          ></ion-select-option
                                        >
                                      </ion-select>
                                    </ion-item>
                                    </ion-col>
                                  </ion-row>
                                  <ion-row *ngIf="tempPermitFormDaily.value['vehicle']==guestVehicleID">
                                    <ion-col>
                                      <ion-item class="paragraph-regular">
                                        <ion-label>{{ ('keys.data.vehicles.plate' | translate : {Default:'Plate'}) ||
                                          'Plate' }}</ion-label>
                                          <ion-input  pattern="^[A-Za-z0-9']*$" maxlength="8"   formControlName="plate"  type="text" (ionChange)="plateChanged()"></ion-input>
                                      </ion-item>
                                    </ion-col>
                                  </ion-row> 
                                  <ion-row *ngIf="dataService.settings.vehicles.guest_vehicle">
                                    <ion-col>
                                      <ion-label class="caption-regular">{{ ('keys.data.permits.temporary_guest_of_instructions' | translate : {Default:"Use 'Guest vehicle' only if you have no vehicle details."}) || "Use 'Guest vehicle' only if you have no vehicle details."}}</ion-label>
                                    </ion-col>
                                  </ion-row>
                                </ion-grid>
                              </ion-card>
                             
                              
                            </ion-col>
                          </ion-row>
                          <ion-row>
                          <ion-col style="text-align: center;" class="ion-padding">
                            <ion-button [disabled]="tempPermitFormDaily.invalid || (tempPermitFormDaily.value['vehicle']==guestVehicleID && tempPermitFormDaily.value['plate'].trim()=='') || formattedEndDate=='Select End Date' || formattedStartDate=='Select Start Date'"  color="primary" (click)="dailyPermitChanged()" >{{ ('keys.data.permits.check_availability' |
                              translate : {Default:'Check availability'}) || 'Check availability' }}</ion-button>
                          </ion-col>
                        </ion-row>
                         
                        </ion-grid>
                      </form>
                    </ng-container>
    
                    <ng-container *ngSwitchCase="'hourly'">
                      <form novalidate [formGroup]="tempPermitFormHourly">
                        <ion-grid class="ion-no-padding">
                          <ion-row>
                            <ion-col>
                              <ion-item class="paragraph-regular"
                              style="cursor: pointer;"
                              [disabled]="tempPermitState.checking"
                              [mode]="platformSRV.mode"
                                clickable
                                lines="none"
                                (click)="showHourlyPickerfunction()"
                              >
                                
                                <ion-label >{{('keys.data.common.date' |
                                  translate : {Default:'Date'}) || 'Date' }} </ion-label>
                                <span style="text-align: right;" *ngIf="formattedHourlyDate!='Select Date'">
                                  {{formattedHourlyDate |
                                    date:dataService.settings['system']['datemask']}}
                                  <ion-icon name="calendar" >
                                  </ion-icon>
                                </span>
                                <span style="text-align: right;" *ngIf="formattedHourlyDate=='Select Date'">
                                  {{formattedHourlyDate}}
                                  <ion-icon name="calendar" >
                                  </ion-icon>
                                </span>
                              </ion-item>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="showHourlyPicker">
                            <ion-col>
                              <ion-datetime
                                minuteValues="00,15,30,45"
                                color="secondary"
                                #datetime3
                                (ionChange)="hourlyDateChanged(datetime3)"
                                min="{{minDate}}"
                                size="auto"
                                display-format="MMMM DD, YYYY"
                                picker-format="MMMM DD, YYYY"
                                formControlName="hourlyDate"
                              >
                              </ion-datetime>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="showHourlyPicker" style="margin-bottom: 0.4em;">
                            
                            <ion-col>
                              <ion-button
                              [disabled]="tempPermitFormHourly.get('hourlyDate').invalid"
                              color="secondary"
                              expand="block"
                                (click)="SavehourlyDate()"
                                >{{('keys.data.common.confirm' |
                                translate : {Default:'Confirm'}) || 'Confirm' }}</ion-button
                              >
                            </ion-col>
                            <ion-col>
                              <ion-button
                                color="secondary"
                                expand="block"
                                fill="outline"
                                (click)="closehourlyDate()"
                                >Cancel</ion-button
                              >
                            </ion-col>
                          </ion-row>
                          <ion-row>
                            <ion-col>
                              <ion-item lines="none" class="paragraph-regular">
                                <ion-label>{{ ('keys.data.permits.temporary_hours' |
                                  translate : {Default:'Hours'}) || 'Hours' }} </ion-label>
                                <ion-select
                               
                                [disabled]="tempPermitState.checking"
                                [mode]="platformSRV.mode"
                                  [interface]="platformSRV.interface"
                                  slot="end"
                                  multiple="false"
                                  formControlName="hours"
                                  (ionChange)="hoursChanged()"
                                >
                                  <ion-select-option
                                  
                                    *ngFor="let hour of lot['Hours']"
                                    [value]="hour.duration"
                                    >{{hour.duration}}</ion-select-option
                                  >
                                </ion-select>
                              </ion-item>
                            </ion-col>
                          </ion-row>
                          <ion-row>
                            <ion-col>
                              <ion-card>
                                <ion-grid>
                                  <ion-row *ngIf="permitsSRV.permit.value['vehicles']">
                                    <ion-col>
                                      
                                        <ion-label>{{('keys.data.vehicles.vehicle' | translate : {Default:'Vehicle'}) || 'Vehicle'}}</ion-label>
                                        
                                    </ion-col>
                                  </ion-row>
                                  <ion-row>
                                    <ion-col>
                                      <ion-item lines="none" >
                                      <ion-select
                                      placeholder="Select Vehicle"
                                      style="font-weight: bold;"
                                        [interface]="platformSRV.interface"
                                        [disabled]="tempPermitState.checking"
                                        [mode]="platformSRV.mode"
                                          [interface]="platformSRV.interface"
                                          multiple="false"
                                          formControlName="vehicle"
                                          (ionChange)="vehiclesChanged()"
                                        >
                                          <ion-select-option
                                            *ngFor="let v of permitsSRV.permit.value['vehicles']"
                                            [value]="v.VehicleID"
                                            >{{ v.ColourName }} {{ v.Year }} {{ v.MakeName
                                            }} {{ v.Plate }}</ion-select-option
                                          >
                                          <ion-select-option [value]="guestVehicleID" *ngIf="dataService.settings.vehicles.guest_vehicle"
                                            ><ng-container *ngIf="dataService.user as user"
                                              >Guest Vehicle -- Guest of {{
                                              dataService.settings.userProfile.preferredName
                                              && user['preferredname'] ?
                                              user['pereferredname'] : user['firstName'] + '
                                              ' + user['lastName'] }}</ng-container
                                            ></ion-select-option
                                          >
                                        </ion-select>
                                      </ion-item>
                                    </ion-col>
                                  </ion-row>
                                  <ion-row *ngIf="tempPermitFormHourly.value['vehicle']==guestVehicleID">
                                    <ion-col>
                                      <ion-item class="paragraph-regular">
                                        <ion-label >{{ ('keys.data.vehicles.plate' | translate : {Default:'Plate'}) ||
                                          'Plate' }}</ion-label>
                                          <ion-input pattern="^[A-Za-z0-9']*$" maxlength="8"    formControlName="plate"  type="text" (ionChange)="plateChanged()"></ion-input>
                                         
                                      </ion-item>
                                    </ion-col>
                                  </ion-row>
                                  <ion-row *ngIf="dataService.settings.vehicles.guest_vehicle">
                                    <ion-col>
                                      <ion-label class="caption-regular">
                                  {{('keys.data.permits.temporary_guest_of_instructions' | translate : {Default:"Use 'Guest vehicle' only if you have no vehicle
                                  details."}) || "Use 'Guest vehicle' only if you have no vehicle
                                  details."}}
                                </ion-label>
                                    </ion-col>
                                  </ion-row>
                                </ion-grid>
                              </ion-card>
                              
                              
                            </ion-col>
                          </ion-row>
                          <ion-row>
                          <ion-col style="text-align: center;" class="ion-padding">
                            <ion-button [disabled]="tempPermitFormHourly.invalid || (tempPermitFormHourly.value['vehicle']==guestVehicleID && tempPermitFormHourly.value['plate'].trim()=='') || formattedHourlyDate=='Select Date'"  color="primary" (click)="hourlyPermitChanged()" >{{ ('keys.data.permits.check_availability' |
                              translate : {Default:'Check availability'}) || 'Check availability' }}</ion-button>
                          </ion-col>
                        </ion-row>
                          
                        </ion-grid>
                      </form>
                    </ng-container>
                  </div>
                
              
            </ion-col>
          </ion-row>
         
        </ion-grid>
      </ion-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="permitType=='hourly'">
      <ion-col>
        <ion-col size="12" *ngIf="tempPermitState.invalid">
          <ion-card
            class="ion-text-wrap card-shadow-3"
            >
            <ion-item lines="none" class="paragraph-regular">
              <ion-label>{{('keys.data.permits.temporary_please_fill_in_all_details' | translate : {Default:'Please fill in all details to purchase a Temporary Permit.'}) || "Please fill in all details to purchase a Temporary Permit."}}</ion-label>
          </ion-item>
          </ion-card>
        </ion-col>
       
        <ion-col size="12" *ngIf="tempPermitState.valid">
         
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col class="ion-no-padding">
                  <ion-item lines="none" class="paragraph-input-fields-regular">
                    <ion-label>{{('keys.data.common.date' | translate : {Default:'Date'}) || "Date"}}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['startDateObject'] |
                  date:dataService.settings['system']['datemask']}}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-no-padding">
                  <ion-item lines="none" class="paragraph-input-fields-regular">
                    <ion-label>{{('keys.data.permits.temporary_start_time' |
                      translate : {Default:'Start Time'}) || 'Start Time' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['startTime']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-no-padding"> 
                  <ion-item lines="none" class="paragraph-input-fields-regular">
                    <ion-label>{{('keys.data.permits.temporary_end_time' |
                      translate : {Default:'End Time'}) || 'End Time' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['endTime']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-no-padding">
                  <ion-item lines="none" class="paragraph-input-fields-regular">
                    <ion-label>{{('keys.data.common.subtotal' |
                      translate : {Default:'Subtotal'}) || 'Subtotal' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['rateMoney']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row *ngFor="let tax of permitDetails?.taxes">
                  <ion-col>
                    <ion-item lines="none" class="paragraph-input-fields-regular">
                      <ion-label>
                        {{ tax?.label  }} {{ tax?.percentage  | round:3}}%
                      </ion-label>
                      <span style="text-align: right">
                        {{ tax?.amount|
                          currency}}
                      </span>
                    </ion-item>
                  </ion-col>
                </ion-row>
              <ion-row>
                <ion-col class="ion-no-padding">
                  <ion-item lines="none" class="paragraph-input-fields-bold">
                    <ion-label>{{('keys.data.common.total_owing' |
                      translate : {Default:'Total Owing'}) || 'Total Owing' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['totalMoney']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-button
                    *ngIf="tempPermitFormHourly.value['hours']==1"
                    (click)="onReservePermit()"
                    expand="block"
                    color="primary"
                    [disabled]="!tempPermitState.valid"
                  >
                  {{ ('keys.data.permits.reserve_permit_for_one_hour' |
  translate :{hours:tempPermitFormHourly.value['hours']}) || 'Reserve Permit for {{hours}} hour' }}
                   
                  </ion-button>
                  <ion-button
                  [disabled]="!tempPermitState.valid"
                    *ngIf="tempPermitFormHourly.value['hours']!=1 && tempPermitFormHourly.value['hours']>0"
                    (click)="onReservePermit()"
                    expand="block"
                    color="primary"
                  >
                  {{ ('keys.data.permits.reserve_permit_for_x_hours' |
                  translate :{hours:tempPermitFormHourly.value['hours']}) || 'Reserve Permit for {{hours}} hours' }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
  
            <!-- Hourly Permit Output End -->
          
        </ion-col>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="permitType=='daily'"> 
      <ion-col>
        <ion-col size="12" *ngIf="tempPermitState.invalid">
          <ion-card
            class="ion-text-wrap"
            >
            <ion-item lines="none" class="paragraph-regular">
            <ion-label
              >{{('keys.data.permits.temporary_please_fill_in_all_details' | translate : {Default:'Please fill in all details to purchase a Temporary Permit.'}) || "Please fill in all details to purchase a Temporary Permit."}}</ion-label
            >
          </ion-item>
          </ion-card>
        </ion-col>
        
        <ion-col size="12" *ngIf="tempPermitState.valid">
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col>
                  <ion-item lines="none">
                    <ion-label>{{('keys.data.permits.start_date' |
                      translate : {Default:'Start Date'}) || 'Start Date' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['startDateObject'] |
                  date:dataService.settings['system']['datemask']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none">
                    <ion-label>{{('keys.data.permits.end_date' |
                      translate : {Default:'End Date'}) || 'End Date' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['endDateObject'] |
                  date:dataService.settings['system']['datemask']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none">
                    <ion-label>{{('keys.data.common.subtotal' |
                      translate : {Default:'Subtotal'}) || 'Subtotal' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['rateMoney']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row *ngFor="let tax of permitDetails?.taxes">
                  <ion-col>
                    <ion-item lines="none" class="paragraph-input-fields-regular">
                      <ion-label>
                        {{ tax?.label  }} {{ tax?.percentage | round:3 }}%
                      </ion-label>
                      <span style="text-align: right">
                        {{ tax?.amount|
                          currency}}
                      </span>
                    </ion-item>
                  </ion-col>
                </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none" style="font-weight: bold">
                    <ion-label>{{('keys.data.common.total_owing' |
                      translate : {Default:'Total Owing'}) || 'Total Owing' }}</ion-label>
                    <ion-label slot="end"
                      >{{ permitDetails['totalMoney']
                      }}</ion-label
                    >
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-button
                  [disabled]="!tempPermitState.valid"
                    *ngIf="days==1 "
                    (click)="onReservePermit()"
                    expand="block"
                    color="primary"
                  >
                  {{ ('keys.data.permits.reserve_permit_for_one_day' |
                  translate : {days:days}) || 'Reserve Permit for {{days}} Day' }}
                   
                  </ion-button>
                  <ion-button
                  [disabled]="!tempPermitState.valid"
                    *ngIf="days>1"
                    (click)="onReservePermit()"
                    expand="block"
                    color="primary"
                  >
                  {{ ('keys.data.permits.reserve_permit_for_x_days' |
                  translate : {days:days}) || 'Reserve Permit for {{days}} Days' }}
                  </ion-button>
                  <ion-button
                  [disabled]="!tempPermitState.valid"
                    *ngIf="days<1"
                    (click)="onReservePermit()"
                    expand="block"
                    color="primary"
                  >
                    Reserve Permit for 1 day
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
  
            <!-- Hourly Permit Output End -->
         
        </ion-col>
      </ion-col>
    </ion-row>
  </ion-grid>
  
  
</ion-content>
